import React from "react";

import { templates } from "@reactivated";

import { ConditionalBlockContent } from "../apps/configurator/ConditionalBlockContent";
import { PDPSelectedRootProductConditionalBlock } from "../apps/configurator/PDPSelectedRootProductConditionalBlock";
import { isoProductID } from "../models/nominals";

export const Template = (
    props: templates.SelectedRootProductConditionalBlockTemplate,
): React.JSX.Element => {
    return (
        <div>
            <PDPSelectedRootProductConditionalBlock
                blockProductID={isoProductID.wrap(props.block_product_id)}
                isInitiallyVisible={props.is_initially_visible}
            >
                <ConditionalBlockContent
                    contentSegments={props.content_segments}
                />
            </PDPSelectedRootProductConditionalBlock>
        </div>
    );
};
